import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { UserEmailSignatureEditModalTemplate } from 'themes/application/user/pages';
import { UserEmailSignatureEditModalViewStore } from 'application/user/stores';

@setCurrentView((rootStore, componentProps) => new UserEmailSignatureEditModalViewStore(rootStore, componentProps), 'userEmailSignatureEditModalViewStore')
@observer
class UserEmailSignatureEditModal extends React.Component {
    render() {
        return <UserEmailSignatureEditModalTemplate {...this.props} />
    }
}

export default UserEmailSignatureEditModal;
